var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"categoryHeading ma-0 pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"full-width pa-0"},[_c('v-tabs',{class:{
          'categoryHeading desktopMenu px-md-5': true,
          'menuPadding': _vm.$vuetify.breakpoint.lgAndUp
        },attrs:{"centered":"","center-active":"","hide-slider":"","optional":"","show-arrows":""}},_vm._l((_vm.categories),function(category){return _c('v-tab',{key:category.id,staticClass:"categoryMenu",attrs:{"exact":"","value":"recent","to":{
            name: _vm.ROUTES.CATEGORY,
            params: { categoryId: category.id, categoryName: category.name }
          }}},[_vm._v(" "+_vm._s(category.name)+" ")])}),1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }